import { create } from 'zustand';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/india/x`;

export const useXSignalsStore = create((set, get) => ({
  posts: [],
  sources: [],
  discoveredAuthors: [],
  lastFetched: null,
  sourceCount: 0,
  isStale: false,
  loading: false,
  refreshing: false,
  error: null,
  feedMode: 'all', // 'all' | 'curated' | 'discovery'

  setFeedMode: (mode) => set({ feedMode: mode }),

  fetchFeed: async (isin) => {
    if (!isin) return;
    set({ loading: true, error: null });
    try {
      const { data } = await axios.get(`${API}/feed/${encodeURIComponent(isin)}`);
      set({
        posts: data.posts || [],
        lastFetched: data.last_fetched,
        sourceCount: data.source_count || 0,
        isStale: data.is_stale || false,
      });

      if (data.is_stale) {
        get().refreshFeed(isin);
      }
    } catch (err) {
      const msg = err.response?.status === 503
        ? 'X Signals feature is not enabled'
        : 'Failed to load X signals';
      set({ posts: [], error: msg });
    } finally {
      set({ loading: false });
    }
  },

  refreshFeed: async (isin, mode) => {
    if (!isin || get().refreshing) return;
    set({ refreshing: true });
    try {
      const fetchMode = mode || 'auto';
      await axios.post(`${API}/fetch/${encodeURIComponent(isin)}?mode=${fetchMode}&limit=25`);
      const { data } = await axios.get(`${API}/feed/${encodeURIComponent(isin)}`);
      set({
        posts: data.posts || [],
        lastFetched: data.last_fetched,
        sourceCount: data.source_count || 0,
        isStale: false,
      });
    } catch (err) {
      console.error('Failed to refresh X signals:', err);
    } finally {
      set({ refreshing: false });
    }
  },

  fetchSources: async (isin) => {
    try {
      const params = isin ? `?isin=${encodeURIComponent(isin)}` : '';
      const { data } = await axios.get(`${API}/sources${params}`);
      set({ sources: data.sources || [] });
    } catch (err) {
      console.error('Failed to fetch X sources:', err);
    }
  },

  fetchDiscoveredAuthors: async () => {
    try {
      const { data } = await axios.get(`${API}/discovered-authors?limit=50`);
      set({ discoveredAuthors: data.authors || [] });
    } catch (err) {
      console.error('Failed to fetch discovered authors:', err);
    }
  },

  clearFeed: () => set({
    posts: [],
    lastFetched: null,
    sourceCount: 0,
    isStale: false,
    error: null,
  }),
}));
